// extracted by mini-css-extract-plugin
export default {"container":"InfoStats-module__container__MTeIF","icon":"InfoStats-module__icon__eCYOk","label":"InfoStats-module__label__8lacY","value":"InfoStats-module__value__91b+Z"};